import React from "react";
import { useTranslation } from 'react-i18next';
import ArrowBack from "../../../assets/icons/arrow_back.svg";
import ChatIcon from "../../../assets/icons/chat.svg";
import History from "../../../assets/icons/watch_later.svg";
import Icon from '../../icon/icon';


const BottomMenuMobile = ({
  showChat,
  trackBackEvent,
  gptSuccess,
  toggleClass,
}) => {
const { t } = useTranslation();
  return (
    <div className="fixed z-sticky bottom-0 left-0 w-screen h-16 bg-DarkBlue-700 px-4 flex flex-row gap-4 items-center justify-between rounded-tl-4 rounded-tr-4">
      <Icon
        icon={ArrowBack}
        iconText={t("regresar")}
        customClassName="gap-1 py-0 w-19"
        onClick={trackBackEvent}
        disabledToolTip={true}
      />
      <Icon
        icon={ChatIcon}
        iconText={"Chat"}
        customClassName="gap-1 py-0 w-19"
        onClick={showChat}
        disabledToolTip={true}
      />
      {!gptSuccess && (
        <Icon
          icon={History}
          iconText={"Historial"}
          customClassName="gap-1 w-19"
          onClick={toggleClass}
          disabledToolTip={true}
        />
      )}
    </div>
  );
};

export default BottomMenuMobile;
